import apiClient from '../axios';

/** 안내문구 카테고리 */
export type GuideCategory = 'SURVEY_GUIDELINE' | 'REWARD_RULE' | 'ATTENDANCE_RULE';

/** 카테고리 한국어 매핑 */
export const GUIDE_CATEGORY_LABELS: Record<GuideCategory, string> = {
  SURVEY_GUIDELINE: '설문 작성 안내',
  REWARD_RULE: '리워드 규칙',
  ATTENDANCE_RULE: '출석 규칙',
};

/** 어드민용 안내문구 아이템 */
export interface AdminGuideItem {
  id: number;
  category: GuideCategory;
  categoryDescription: string;
  content: string;
  sortOrder: number;
  isActive: boolean;
  regDateTime: string;
  modDateTime: string;
}

/** 안내문구 생성 요청 */
export interface CreateGuideRequest {
  category: GuideCategory;
  content: string;
  sortOrder?: number;
  isActive?: boolean;
}

/** 안내문구 수정 요청 */
export interface UpdateGuideRequest {
  content?: string;
  sortOrder?: number;
  isActive?: boolean;
}

const ADMIN_GUIDES_URL = () => '/api/admin/guides';

export const guideApi = {
  /** 전체 안내문구 목록 조회 (어드민용) */
  getAll: () => {
    return apiClient.get<{ results: AdminGuideItem[] }>(`${ADMIN_GUIDES_URL()}`);
  },

  /** 안내문구 생성 */
  create: (params: CreateGuideRequest) => {
    return apiClient.post<{ id: number }>(`${ADMIN_GUIDES_URL()}`, params);
  },

  /** 안내문구 수정 */
  update: (id: number, params: UpdateGuideRequest) => {
    return apiClient.put(`${ADMIN_GUIDES_URL()}/${id}`, params);
  },

  /** 안내문구 삭제 */
  delete: (id: number) => {
    return apiClient.delete(`${ADMIN_GUIDES_URL()}/${id}`);
  },
};
